export const PHONE_CASES_CATEGORIES_MENU_CONFIG = {
  id: 'phone-cases',
  displayName: 'Phone cases',
  subCategories: [
    { id: 'phone-cases', displayName: 'All' },
    { id: 'builder', displayName: 'Create tour custom case' },
    { id: 'builder', displayName: 'Builder' },
  ],
};
